import { Injectable } from "@angular/core";
import { Actions } from "@ngrx/effects";
import { AuthActions } from "./auth.actions";

@Injectable()
export class AuthEffects {
  constructor(private actions$: Actions<AuthActions>) {}
}
